import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import SportsTeamLogo from '../../../../components/teamLogo';
import { FormatUtil } from '../../../../common/utils/formatUtil';
import {getIframeBrowser} from "../../liveStream/util";

const SoccerView = observer(({ item, setSelectedGame, isSelected }) => {
  const {
    getTeamData,
    statusData,
    getTracker,
    winnerTeam,
    getProgressTime,
    id,
    startDatetime,
    gameStatus,
    statusText,
    cheerCount
  } = item;

  const setSelectedItem = () => {
    setSelectedGame(isSelected, id);
  };
  const onClickVideo = () => {
    // getStreamBrowser(item.videoLink);
    getIframeBrowser(item.videoLink);
  };

  return (
    <div className={clsx('item', getTracker.status)}>
      <Link
        className="box"
        to={`/match/soccer/${id}/odds`}
        onClick={() => window.reflowOnFocus()}
      >
        <div className="team left">
          <span className="name">{getTeamData.home.name}</span>
          <SportsTeamLogo
            className="logo"
            imgSize={30}
            imgUrl={getTeamData.home.imgPath}
            isLazy={false}
            location="home"
          />
        </div>
        <div className="info">
          <div className="score">
            <strong
              className={clsx(
                'left',
                !winnerTeam.isPk && winnerTeam.activeScore === 'home' && 'on'
              )}
            >
              <em className="num">{getTeamData.home.score}</em>
              {winnerTeam.isPk && (
                <em
                  className={clsx(
                    'p',
                    winnerTeam.activeScore === 'home' && 'on'
                  )}
                >
                  {getTeamData.home.pkScore}
                </em>
              )}
            </strong>
            <strong
              className={clsx(
                'right',
                !winnerTeam.isPk && winnerTeam.activeScore === 'away' && 'on'
              )}
            >
              <em className="num">{getTeamData.away.score}</em>
              {winnerTeam.isPk && (
                <em
                  className={clsx(
                    'p',
                    winnerTeam.activeScore === 'away' && 'on'
                  )}
                >
                  {getTeamData.away.pkScore}
                </em>
              )}
            </strong>
          </div>

          <div className="state">
            {getTracker.status === 'progress' && statusText !== 'HT' && (
              <>
                <span>{statusText}</span>
                <span>{`${getProgressTime.soccerTime}분`}</span>
              </>
            )}
            {(getTracker.status === 'final' || statusText === 'HT') &&
              statusData.statusText}
            <span className="clock">{statusData.date}</span>
            {cheerCount >= 100 && (
              <span className="count">
                {FormatUtil.numberUnitConvert(cheerCount)}
              </span>
            )}
          </div>
          <div className="time">
            <div>
              <span className="clock">{statusData.date}</span>
              {cheerCount >= 100 && (
                <span className="count">
                  {FormatUtil.numberUnitConvert(cheerCount)}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="team right">
          <SportsTeamLogo
            className="logo"
            imgSize={30}
            imgUrl={getTeamData.away.imgPath}
            isLazy={false}
            location="away"
          />
          <div className="name">{getTeamData.away.name}</div>
        </div>
      </Link>
      {!!item.videoLink && (gameStatus === "IN_PROGRESS" || gameStatus === "BREAK_TIME" || gameStatus === "PAUSE") && (
        <button type="button" className="on_air" title="생중계"
          onClick={onClickVideo}
        >
          생중계</button>
      )}
      <button
        type="button"
        className={!!item.videoLink && (gameStatus === "IN_PROGRESS" || gameStatus === "BREAK_TIME" || gameStatus === "PAUSE") ? clsx('btn_favorites', isSelected && 'selected') : clsx('live', clsx('btn_favorites', isSelected && 'selected'))}
        onClick={setSelectedItem}
      >
        관심경기 추가
      </button>
    </div>
  );
});

export default SoccerView;
